"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("g", {
    id: "New_Icons"
  }, (0, _core.jsx)("path", {
    d: "M101.3,437.5c-20.8-1.4-37.3-18-38.8-38.8C64.6,419.2,80.8,435.4,101.3,437.5z"
  }), (0, _core.jsx)("path", {
    d: "M437.5,398.8c-1.4,20.8-18,37.3-38.8,38.8C419.2,435.4,435.4,419.2,437.5,398.8z"
  }), (0, _core.jsx)("path", {
    d: "M395.8,104.2H104.2c-23,0-41.7,18.7-41.7,41.7v248.5c-0.1,1.5-0.1,2.9,0,4.4c2.1,20.4,18.3,36.6,38.8,38.8h297.5 c20.4-2.1,36.6-18.3,38.8-38.8c0.1-1.5,0.1-2.9,0-4.4V145.8C437.5,122.8,418.8,104.2,395.8,104.2z M250,375 c-57.5,0-104.2-46.6-104.2-104.2S192.5,166.7,250,166.7s104.2,46.6,104.2,104.2S307.5,375,250,375z M375,187.5 c-11.5,0-20.8-9.3-20.8-20.8s9.3-20.8,20.8-20.8s20.8,9.3,20.8,20.8S386.5,187.5,375,187.5z"
  }), (0, _core.jsx)("circle", {
    cx: "250",
    cy: "270.8",
    r: "62.5"
  }), (0, _core.jsx)("path", {
    d: "M354.2,125v20.8H145.8V125L176,72.9c3.7-6.5,10.7-10.4,18.1-10.4h111.7c7.5,0,14.4,3.9,18.1,10.4L354.2,125z"
  }));
};

exports.default = _default;